$(document).ready(function (){

    const neighborhoods = {
        "All Neighborhoods": "",
        "Lakeview": "lakeview",
        "Gold Coast": "gold-coast",
        "Lincoln Park": "lincoln-park",
        "Wrigleyville": "wrigleyville",
        "Logan Square": "logan-square",
        "Lincoln Square and Ravenswood": "lincoln-square-ravenswood",
        "Bucktown": "bucktown",
        "Evanston": "evanston",
        "Glencoe": "glencoe",
        "Highland Park": "highland-park",
        "Northfield": "northfield",
        "Winnetka": "winnetka"
    };
    const bedrooms = {
        "Bedrooms": "",
        "Studio": "studio",
        "1 Bed": "1-bed",
        "2 Beds": "2-beds",
        "3 Beds": "3-beds"
    };

/*    $('body').on('click', '.dropdown_checked:not(.open)', function (e){
        e.preventDefault();
        $(this).addClass('open');
        $(this).parent().siblings('.dropdown_list').slideDown(150).attr('aria-hidden', false);
        $(this).attr('aria-expanded', true);
    });

    $('body').on('click', '.dropdown_checked.open', function (e){
        e.preventDefault();
        $(this).removeClass('open');
        $(this).parent().siblings('.dropdown_list').slideUp(150).attr('aria-hidden', true);
        $(this).attr('aria-expanded', false);
    });


    $('body').on('click', '.dropdown_list__item', function (e){
        e.preventDefault();

        $('.dropdown_list__item').removeClass('selected');
        $(this).addClass('selected');

        let checkedItemText = $(this).text();
        let dropdownList = $(this).closest('.dropdown_list');
        dropdownList.siblings('label').find('.dropdown_checked').text(checkedItemText);
        dropdownList.siblings('label').find('.dropdown_checked').removeClass('open');
        dropdownList.siblings('label').find('.dropdown_checked').attr('aria-expanded', false);
        dropdownList.slideUp(150).attr('aria-hidden', true);

        if($(this).data('name') === 'price'){
            const parts = $(this).data('value').split('-');
            const min = parts[0].trim().substring(1);
            const max = parts[1].trim().substring(1);

            $('input[name="price_min"]').val(min);
            $('input[name="price_max"]').val(max);
        } else {
            $('input[name='+$(this).data('name')+']').val($(this).data('value'));
        }
    });*/

    $('form[action="/find-an-apartment/"]').on('submit', function (e) {
        e.preventDefault();

        $('[name="neighborhood"]').val(neighborhoods[$('#combo1').text()]);
        $('[name="beds"]').val(bedrooms[$('#combo2').text()]);

        let price = $('#combo3').text();
        if(price != 'Any Price') {
            const parts = price.split('-');

            if(parts.length > 1){
                const min = parts[0].trim().substring(1);
                const max = parts[1].trim().substring(1);

                $('input[name="price_min"]').val(min);
                $('input[name="price_max"]').val(max);
            } else {
                $('input[name="price_min"]').val('4000');
            }
        }


        const form = $(this);
        const params = [];

        form.find('input[type="hidden"]').each(function () {
            const name = encodeURIComponent(this.name);
            const value = encodeURIComponent(this.value).replace(/%2C/g, ',');
            if(value){
                params.push(`${name}=${value}`);
            }
        });

        const queryString = params.join('&');
        const targetUrl = form.attr('action') + '?' + queryString;

        // console.log(targetUrl);

        window.location.href = targetUrl;
    });

    $('body').on('click', '#scroll_bottom', function(){
        $('html, body').animate({scrollTop: ($('.wrapper_home_featured_properties').offset().top - 104) + 'px'}, 500)
    });


    if ($('.wrapper_home_banner video').get(0).paused) {
        $('#play_pause .icon-play').show();
        $('#play_pause .icon-pause').hide();
    } else {
        $('#play_pause .icon-play').hide();
        $('#play_pause .icon-pause').show();
    }

    $('#play_pause').on('click', function () {
        if ($('.wrapper_home_banner video').get(0).paused) {
            $('.wrapper_home_banner video').get(0).play();
            $('#play_pause .icon-play').hide();
            $('#play_pause .icon-pause').show();
        } else {
            $('.wrapper_home_banner video').get(0).pause();
            $('#play_pause .icon-play').show();
            $('#play_pause .icon-pause').hide();
        }
    });
});

